import Srcset from '@/components/common/Srcset';
import React from 'react'

const NoOrder = (props) => {
  
  const { styles } = props;
  return (
    <div className={`${styles.account_card}`}>
      <div className={`${styles.account_back}`}>
        <a  onClick={() => {props.activeTab('')}}>
          <Srcset
            requirePath={true}
            svgFile={true}
            className={'back_icon'}
            src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
            alt="back button"
            height="16"
            width="19.11"
            tabIndex={0}
          />
        </a>
        <Srcset
            onClick={() => {props.setAccountSidebarOpen(false);props.activeTab('')}}
            requirePath={true}
            svgFile={true}
            className={'close_icon_account_tab'}
            src={"images/Icons/Cross/Large.svg"}
            alt="cloe button"
            height="16"
            width="19.11"
          />
      </div>
      <div className={`${styles.card_head} ${styles.no_order}`}>
        <div className={`${styles.card_title} x-large-xs xx-large-sm xx-large-md light`}>Your Orders</div>
        <div className={`${styles.card_action} xx-small-xs small-sm small-md`}>0 orders</div>
      </div>
      <div className={`${styles.card_body}`}>
        <p className={`${styles.no_order_message}`}>You do not have any orders.</p>
      </div>
    </div>
  )
}

export default NoOrder